import { React } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import AdxModuleDashboardGrid from 'components/reusable/grids/AdxModuleDashboardGrid'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import LeaveCreditTable from 'module/leave/pages/leaveCreditRequest/components/LeaveCreditTable'
import LearnMoreModal from 'module/leave/pages/leaveCreditRequest/components/LearnMoreModal'
import { Grid } from '@mui/material'

const CreditRequest = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const handleCreateNewRequest = () => {
    navigate('/app/leave/leave_credit/create', {
      state: {
        backgroundLocation: location,
      },
    })
  }

  return (
    <DashboardContainer headerTitle="Leave Credit Request">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: { xs: 1, md: '65%' } }}>
            <AdxActionButton
              sx={{
                width: 1,
                border: 1,
                borderRadius: '4.5px',
                borderColor: 'gray-line.main',
              }}
              icon="calendar_today"
              icon2="chevron_right"
              iconColor="alternate.main"
              iconBgColor="alternate.light"
              title="Request for Leave Credit"
              description="Only for leaves without entitlement"
              actionMessage="Request"
              onClick={handleCreateNewRequest}
              divClick
            />
          </Box>
          <Box sx={{ width: { xs: 1, md: '35%' } }}>
            <Typography variant="subtitle2" color="dark-text.main">
              Prepare proper documentation as proof of Management's acknowledgement and agreeement
              of your overtime before requesting for replacement.
            </Typography>
            <LearnMoreModal />
          </Box>
        </Box>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h4" fontWeight="bold" color="dark-text.main">
            My Leave Credit Request
          </Typography>
          <Box
            sx={{
              width: '100%',
              minHeight: 'calc(100% - 40px)',
              borderRadius: '4.5.px',
            }}
          >
            <LeaveCreditTable />
          </Box>
        </Box>
      </Box>
    </DashboardContainer>
  )
}

export default CreditRequest
